import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";

export enum Days {
  monday = "monday",
  tuesday = "tuesday",
  wednesday = "wednesday",
  thursday = "thursday",
  friday = "friday",
  saturday = "saturday",
  sunday = "sunday",
}

export type Option = {
  value: string;
  label: string;
  birthDate?: string;
  [key: string]: any;
  color?: string;
};

export type NavDataType = {
  label: string;
  path?: string;
  value: string;
  children?: NavDataType[];
  icon?: OverridableComponent<SvgIconTypeMap<{}, "svg">> & {
    muiName: string;
  };
};

export type PickedWeekDayTimes = Partial<
  Record<
    Days,
    {
      open?: string | null;
      close?: string | null;
    }[]
  >
>;

export enum AppointmentStatusEnum {
  completed = "completed",
  checked_in = "checked_in",
  waiting_room = "waiting_room",
  in_exam_room = "in_exam_room",
  scheduled = "scheduled",
  not_confirmed = "not_confirmed",
  confirmed = "confirmed",
  in_room_intake = "in_room_intake",
  cancelled = "cancelled",
  no_show = "no_show",
}

export const DAY_CHOICES = [
  { value: "monday", label: "Monday" },
  { value: "tuesday", label: "Tuesday" },
  { value: "wednesday", label: "Wednesday" },
  { value: "thursday", label: "Thursday" },
  { value: "friday", label: "Friday" },
  { value: "saturday", label: "Saturday" },
  { value: "sunday", label: "Sunday" },
];

export const DAY_OF_WEEK_OPTIONS: Option[] = [
  { value: Days.sunday, label: "Sun" },
  { value: Days.monday, label: "Mon" },
  { value: Days.tuesday, label: "Tue" },
  { value: Days.wednesday, label: "Wed" },
  { value: Days.thursday, label: "Thu" },
  { value: Days.friday, label: "Fri" },
  { value: Days.saturday, label: "Sat" },
];
